import { atom } from 'jotai'

/**
 * Where the quote's auto-save has got to.
 *
 *   PENDING -> SYNCING -> IDLE
 *   (queued)   (saving)   (nothing on its way)
 *
 * A save already running stays SYNCING when another edit queues behind it, so
 * the header doesn't drop its spinner mid-save. That does mean IDLE only says
 * the last save came back, not that every edit reached the server - the same
 * as it has always been.
 */
export type QuoteSyncStatus = 'PENDING' | 'SYNCING' | 'IDLE'

export const quoteSyncStatusAtom = atom<QuoteSyncStatus>('IDLE')
